import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { Props } from './PauseSubscriptionSuccessDialog.types';

export const renderPauseSubscriptionSuccessDialog = (data: Props) =>
    openPopupHelper({ popupName: popupNames.PAUSE_SUBSCRIPTION_SUCCESS, data });

export const closePauseSubscriptionSuccessDialog = () => closePopupHelper(popupNames.PAUSE_SUBSCRIPTION_SUCCESS);
